import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';


import { makeStyles } from 'tss-react/mui';
import { Grid, MUIDataTable, MUIDataTableColumnDef } from 'web-library';
import { stringToSemanticDisplay } from '../../../utils/DateUtils';
import FormHeader from '../../../components/form-items/FormHeader';
import { ISelectionModels } from '../../../api/candidate/special-consideration/model';

export interface SubjectTableProps {
  data: ISelectionModels[];
}

const useStyles = makeStyles()((theme) =>
({
  examLevelTable: {
    paddingBottom: theme.spacing(7),
  },
}));

const SubjectTable = ({ data }: SubjectTableProps) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  const columns: MUIDataTableColumnDef[] = useMemo(
    () => [
      {
        label: t('specialConsideration->>ApplyForSpecialConsideration.SubjectPapers'),
        name: 'subject',
      },
      {
        label: t('specialConsideration->>ApplyForSpecialConsideration.ExamDate'),
        name: 'examDate',
        options: {
          filter: true,
          setCellProps: () => ({
            style: {
              width: '13%',
            },
          }),
          customBodyRenderLite: (dataIndex: number, rowIndex: number) => {
            if (dataIndex === undefined || data === undefined) {
              return [];
            }

            const currentRow = data[dataIndex];

            return stringToSemanticDisplay(currentRow.examDate);
          },
        },
      },
      {
        label: t('specialConsideration->>ApplyForSpecialConsideration.ModeOfAssessment'),
        name: 'modeOfAssessment',
      },
      {
        label: t('specialConsideration->>ApplyForSpecialConsideration.Type'),
        name: 'specialConsiderationType',
      },
      {
        label: t('specialConsideration->>ApplyForSpecialConsideration.Reason'),
        name: 'reason',
      },
      {
        name: 'explanation',
        label: t('specialConsideration->>ApplyForSpecialConsideration.Remarks'),
      },
    ],
    [t, data]
  );

  return (
    <Grid sm={12} className={classes.examLevelTable}>
      <FormHeader title={t('specialConsideration->>ApplyForSpecialConsideration.SubjectPapers')} />
      <MUIDataTable columns={columns} data={data} />
    </Grid>
  );
};

export default SubjectTable;
